export default __webpack_public_path__ + "static/media/together.832f90d2.jpg";